import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import numberFormat from '../../utils/numberFormat';
import openWithAppTalk from '../../utils/openWithAppTalk';
import { isInAppWebView } from '../../utils/deviceUtil';
import * as actions from '../../actions';

export class ProfileListItem extends Component {
  constructor(props) {
    super(props);
    this.handleClickAddFriend = this.handleClickAddFriend.bind(this);
    this.handleClickChat = this.handleClickChat.bind(this);
    this.handleClickRow = this.handleClickRow.bind(this);
    this.setCallbackProfileHandler = this.setCallbackProfileHandler.bind(this);
    this.callbackAddFriend = this.callbackAddFriend.bind(this);
    this.callbackBlockFriend = this.callbackBlockFriend.bind(this);
    this.state = {
      isFriendStatus: ''
    }
  }

  handleClickRow(e) {
    if (e) {
      e.preventDefault();
    }
    const { device, profile } = this.props;

    if (!isInAppWebView(device)) {
      alert('카카오톡 모바일앱에서 가능합니다.');
      return;
    }
    this.setCallbackProfileHandler();
    openWithAppTalk(device, `plusfriend/home/@${profile.get('uuid')}/`);
  }

  handleClickAddFriend(e) {
    if (e) {
      e.preventDefault();
    }
    const { device, profile } = this.props;
    const profileId = profile.get('id');

    if (!isInAppWebView(device)) {
      alert('카카오톡 모바일앱에서 가능합니다.');
      return;
    }

    this.setCallbackProfileHandler();
    const osName = device.getIn(['os', 'name']);
    if (osName === 'iOS') {
      openWithAppTalk(device, `?id=${profileId}&status=0`, 'plus');
    } else if (osName === 'Android') {
      window.kakaotalk.process(profileId, 0);
    }
  }

  handleClickChat(e) {
    if (e) {
      e.preventDefault();
    }
    const { device, profile } = this.props;
    const uuid = profile.get('uuid');
    if (!isInAppWebView(device)) {
      alert('카카오톡 모바일앱에서 가능합니다.');
      return;
    }
    openWithAppTalk(device, `plusfriend/talk/chat/@${uuid}/`);
  }

  setCallbackProfileHandler() {
    window.change_status = (code) => {
      if (code === 1) {
        this.callbackAddFriend();
      } else if (code === 2) {
        this.callbackBlockFriend();
      }
    };
    window.callbackAddFriend = this.callbackAddFriend;
    window.callbackBlockFriend = this.callbackBlockFriend;
  }
  
  callbackAddFriend() {
    if (isEmpty(this.props.reduxProfileNames)) {
      this.setState({ isFriendStatus: 'add' });
    } else {
      this.props.handleAddFriend(this.props.profile.get('id'), this.props.reduxProfileNames);
    }
  }

  callbackBlockFriend() {
    if (isEmpty(this.props.reduxProfileNames)) {
      this.setState({ isFriendStatus: 'block' });
    } else {
      this.props.handleBlockFriend(this.props.profile.get('id'), this.props.reduxProfileNames);
    }
  }
  
  render () {
    const { index, profile, isRankType } = this.props;
    const { isFriendStatus } = this.state;
    const profileName = profile.get('name');
    const convertedName = isRankType ? ' ' + profileName : profileName;
    const convertedDesc = isRankType ? `친구 ${numberFormat(profile.get('friendIncrCount'))}명 증가 ` : profile.get('statusMessage');
    const isChatBot = profile.get('publicProfileBot') && profile.getIn(['publicProfileBot','isBotBuilder'])
      && profile.getIn(['publicProfileBot','status']) === 'R';
    const isChat = (!isChatBot) && profile.get('isChat');
    const isFriend = profile.get('isFriend') || false;
    const profileId = profile.get('id');
    const uuid = profile.get('uuid');
    const isNoDesc = isEmpty(convertedDesc);
    const isShowAddFriend = isFriendStatus === 'block' || (isFriendStatus === '' && (!isFriend));
    const buttonCount = ((isChatBot || isChat) ? 1 : 0) + (isShowAddFriend ? 1 : 0);
    const classNames = buttonCount == 0 ? '' : `item_type${buttonCount}`;

    return (
      <li className={classNames} data-tiara-layer="profile_item">
        <a className="link_plus" href="#home"
           onClick={(e) => {this.handleClickRow(e);}}
           data-tiara-id={profileId} data-tiara-type="pfid" data-tiara-name={profileName} data-tiara-ordnum={index}
           data-tiara-click_url={`//plusfriend/home/@${profile.get('uuid')}`}
           data-tiara-layer="profile_home"
        >
          <div className="circle_thumb">
            <img src={profile.get('profileImagePath')} width={45} height={45} className="thumb_g" alt="" />
          </div>
          <div className="info_thumb">
            <div className="innner_info">
              <strong className="tit_subject">
                {isRankType && (<span className="num_rank">{index + 1}</span>)}
                {convertedName}
              </strong>
                {!isNoDesc && (
                  <p className="desc_story">
                    {convertedDesc}
                    {isRankType && (<span className="ico_plus ico_up" />)}
                  </p>
                )}
            </div>
          </div>
        </a>
        <div className="scope_btn">
          {isChat && (
            <a className="ico_plus ico_chat" href="#chat"
               onClick={(e) => {this.handleClickChat(e);}}
               data-tiara-id={profileId} data-tiara-type="pfid" data-tiara-name={profileName} data-tiara-ordnum={index}
               data-tiara-click_url={`//plusfriend/talk/chat/@${uuid}`}
               data-tiara-layer="open_chat"
            >
              채팅
            </a>
          )}
          {isChatBot && (
            <a className="ico_plus ico_bot" href="#bot"
               onClick={(e) => {this.handleClickChat(e);}}
               data-tiara-id={profileId} data-tiara-type="pfid" data-tiara-name={profileName} data-tiara-ordnum={index}
               data-tiara-click_url={`//plusfriend/talk/chat/@${uuid}`}
               data-tiara-layer="open_chat"
            >
              봇
            </a>
          )}
          {isShowAddFriend && (
            <a className="ico_plus ico_friend" href="#add"
               onClick={(e) => {this.handleClickAddFriend(e);}}
               data-tiara-id={profileId} data-tiara-type="pfid" data-tiara-name={profileName} data-tiara-ordnum={index}
               data-tiara-click_url={`//plusfriend/addfriend/${profileId}`}
               data-tiara-layer="add_friend"
            >
              채널 추가
            </a>
          )}
        </div>
      </li>
    );
  }
}

ProfileListItem.propTypes = {
  device: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  profile: PropTypes.object.isRequired,
  isRankType: PropTypes.bool,
  reduxProfileNames: PropTypes.array
};

ProfileListItem.defaultProps = {
  isRankType: false,
  reduxProfileNames: []
};

export default connect(
  null,
  (dispatch) => bindActionCreators({
    handleAddFriend: actions.addFriend,
    handleBlockFriend: actions.blockFriend
  }, dispatch)
)(ProfileListItem);


// WEBPACK FOOTER //
// ./src/components/ProfileList/ProfileListItem.js